export const STATIC_REALM_ID = "dd180bca-465a-470a-abe4-9d5a15ded551";
export const STATIC_USER_ID = "1";
const baseUrl = process.env.REACT_APP_NINJA_ADMIN_BASE_URL;

const paths = {
  triggerEmailOtp: () =>
    `https://${baseUrl}/workflow-engine/${STATIC_REALM_ID}/${STATIC_USER_ID}/v1/execution/service/runWithNoAuth/login-otp`,
  verifyEmailOtp: () =>
    `https://${baseUrl}/workflow-engine/${STATIC_REALM_ID}/${STATIC_USER_ID}/v1/execution/service/runWithNoAuth/signup-signin`,
  fetchUserRoles: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/admin-tool-roles-fetch`,
  fetchRolesIMS: (userId) =>
    `https://${baseUrl}/iam/api/v1/realm/$REALM_ID/user/${userId}/roles-privileges`,
  fetchDocumentDetails: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/get-realm-by-contact`,
  updateUserName: () =>
    `https://${baseUrl}/profile-service/$REALM_ID/$USER_ID/organization/details`,
  updateUserMobile: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/update-phone-number`,
  fetchKycDetails: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/fetch-kyc-with-contact`,
  fetchPresignedUrls: () =>
    `https://${baseUrl}/dam/api/v1/realms/$REALM_ID/users/$USER_ID/presign-url`,
  rejectDocuments: () => `https://${baseUrl}/kyc/userDocument/rejectDocument`,
  getMultipleDetails: () =>
    `https://${baseUrl}/profile-service/$REALM_ID/$USER_ID/sn-org-profile/fetchMultiple`,
  getStateList: () =>
    `https://${baseUrl}/profile-service/$REALM_ID/$USER_ID/state/${process.env.REACT_APP_COUNTRY}`,
  getCityList: () =>
    `https://${baseUrl}/profile-service/$REALM_ID/$USER_ID/city`,
  getMarketList: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/get-city-based-facility`,
  getOrganizationProfile: (systemUserId, realmID, id) =>
    `https://${baseUrl}/profile-service/${realmID}/${systemUserId}/organization/${id}`,
  createProject: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/create-project`,
  getAllProjects: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/get-all-projects`,
  createSegment: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/create-segment`,
  getAllSegments: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/get-all-segments`,
  getAllContexts: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/get-all-contexts`,
  createFeature: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/create-feature`,
  createTreatments: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/create-treatments`,
  getAllFeatures: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/get-all-features`,
  getAllTreatments: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/get-all-treatments`,
  deleteTreatments: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/delete-treatments`,
  createContext: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/create-context`,
  addSegmentValue: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/add-segments-value`,
  getSegmentValue: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/get-segment-values`,
  deleteSegmentValue: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/delete-segment-values`,
  getTreatmentValue: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/get-treatment-values`,
  getMappedSegments: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/get-mapped-segments`,
  addTreatmentsValue: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/add-treatments-value`,
  deleteTreatmentsValue: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/delete-treatment-values`,
  addMappedSegments: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/add-mapped-segments`,
  getSegmentName: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/get-segment-name`,
  deleteMappedSegment: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/delete-mapped-segment`,
  editTreatment: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/edit-treatment`,
  updateFeatureDetails: () =>
    `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/update-feature-details`,
  getCollectionRequest : () =>
    `https://${baseUrl}/dam/api/v1/realms/1/users/1/collection-request-templates/search`,
  createCollectionRequest: () => 
    `https://${baseUrl}/dam/api/v1/realms/1/users/1/collection-request-templates`,
  updateCollectionRequest: (id) =>
     `https://${baseUrl}/dam/api/v1/realms/1/users/1/collection-request-templates/${id}`,
  getAssetName: () =>
    `https://${baseUrl}/dam/api/v1/realms/1/users/1/digital-asset-definitions/search`
};

export default paths;
